/**
 * Curated list of Iconify icons that speakers can choose from when creating custom mediums.
 * Each entry maps a human-readable key to an Iconify icon identifier.
 */
export const availableMediumIcons = [
    { id: 'fa-solid--ad', labelEn: 'Advertising', labelDe: 'Werbung' },
    { id: 'fa6-solid--info', labelEn: 'Info / Education', labelDe: 'Info / Bildung' },
    { id: 'fa6-brands--square-instagram', labelEn: 'Social Media', labelDe: 'Soziale Medien' },
    { id: 'mingcute--announcement-fill', labelEn: 'Announcement', labelDe: 'Ansage' },
    { id: 'mdi--movie-roll', labelEn: 'Film / Movie', labelDe: 'Film' },
    { id: 'mdi--microphone', labelEn: 'Microphone', labelDe: 'Mikrofon' },
    { id: 'mdi--podcast', labelEn: 'Podcast', labelDe: 'Podcast' },
    { id: 'mdi--headphones', labelEn: 'Audio / Headphones', labelDe: 'Audio / Kopfhörer' },
    { id: 'mdi--book-open-page-variant', labelEn: 'Audiobook', labelDe: 'Hörbuch' },
    { id: 'mdi--phone-in-talk', labelEn: 'Phone / IVR', labelDe: 'Telefon / IVR' },
    { id: 'mdi--cellphone', labelEn: 'Mobile App', labelDe: 'Mobile App' },
    { id: 'mdi--monitor', labelEn: 'Screen / Display', labelDe: 'Bildschirm / Display' },
    { id: 'mdi--gamepad-variant', labelEn: 'Gaming', labelDe: 'Gaming' },
    { id: 'mdi--shopping-outline', labelEn: 'E-Commerce', labelDe: 'E-Commerce' },
    { id: 'mdi--cart-outline', labelEn: 'Shop / Retail', labelDe: 'Laden / Einzelhandel' },
    { id: 'mdi--school', labelEn: 'Education', labelDe: 'Bildung' },
    { id: 'mdi--hospital-box', labelEn: 'Healthcare', labelDe: 'Gesundheitswesen' },
    { id: 'mdi--airplane', labelEn: 'Travel / Transport', labelDe: 'Reise / Transport' },
    { id: 'mdi--music', labelEn: 'Music', labelDe: 'Musik' },
    { id: 'mdi--television-classic', labelEn: 'Television', labelDe: 'Fernsehen' },
    { id: 'mdi--radio', labelEn: 'Radio', labelDe: 'Radio' },
    { id: 'mdi--youtube', labelEn: 'YouTube', labelDe: 'YouTube' },
    { id: 'mdi--presentation', labelEn: 'Presentation', labelDe: 'Präsentation' },
    { id: 'mdi--web', labelEn: 'Website', labelDe: 'Webseite' },
    { id: 'mdi--account-group', labelEn: 'Corporate', labelDe: 'Unternehmen' },
    { id: 'mdi--bullhorn', labelEn: 'Marketing', labelDe: 'Marketing' },
    { id: 'mdi--meditation', labelEn: 'Meditation / Wellness', labelDe: 'Meditation / Wellness' },
    { id: 'ant-design--api-filled', labelEn: 'API / Interface', labelDe: 'API / Schnittstelle' },
] as const;

export type MediumIconId = (typeof availableMediumIcons)[number]['id'];

/**
 * Default mediums to create for new speakers.
 * These mirror the original global mediums with their translations.
 */
export const defaultMediums = [ {
    name: 'social-media',
    icon: 'fa6-brands--square-instagram',
    titleEn: 'Social Media',
    titleDe: 'Soziale Medien',
    examplesEn: 'Facebook, YouTube, Instagram, TikTok',
    examplesDe: 'Facebook, YouTube, Instagram, TikTok'
}, {
    name: 'info-videos',
    icon: 'fa6-solid--info',
    titleEn: 'Info Videos',
    titleDe: 'Info-Videos',
    examplesEn: 'E-Learning, Product video, Image video',
    examplesDe: 'E-Learning, Produktvideo, Imagevideo'
}, {
    name: 'public',
    icon: 'mingcute--announcement-fill',
    titleEn: 'Public',
    titleDe: 'Öffentlich',
    examplesEn: 'Fire alarm, PA, Shooter alarm',
    examplesDe: 'Feueralarm, Lautsprecheransagen, Amok-Alarm'
}, {
    name: 'commercials',
    icon: 'fa-solid--ad',
    titleEn: 'Commercials',
    titleDe: 'Werbung',
    examplesEn: 'TV, Billboards, YouTube and Radio',
    examplesDe: 'TV, Plakatwände, YouTube und Radio'
}, {
    name: 'e-learning',
    icon: 'fa6-solid--info',
    titleEn: 'E-Learning',
    titleDe: 'E-Learning',
    examplesEn: 'Online courses, training videos, tutorials',
    examplesDe: 'Online-Kurse, Schulungsvideos, Tutorials'
} ] as const;
